import { toLnglat, toPixel } from "../utils";
/** 动态属性 */
export var configurableProps = ['anchor', 'angle', 'animation', 'clickable', 'content', 'cursor', 'draggable', 'shape', 'icon', 'label', 'offset', 'position', 'raiseOnDrag', 'shadow', 'title', 'extData',
// 自定义支持
'zIndex', 'visible'];
export var allProps = configurableProps.concat(['topWhenClick', 'bubble', 'autoRotation']);
export var setterMap = {
  visible: function visible(val, instance) {
    if (instance) {
      if (val) {
        instance.show();
      } else {
        instance.hide();
      }
    }
  },
  zIndex: function zIndex(val, instance) {
    if (instance) {
      instance.setzIndex(val);
    }
  }
};
export var converterMap = {
  position: toLnglat,
  offset: toPixel
};